import React from 'react';
import './Header.css';

function Header({ onLogoClick }) {
  return (
    <div className="header">
      <div className="header-spacer"></div>
      <button className="logo-button" onClick={onLogoClick}>
        <span className="logo">knowroom</span>
      </button>
    </div>
  );
}

export default Header;
